module.exports = __webpack_public_path__ + "img/logo.70d38089.png";